/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

/* eslint-disable */

///////////////////
//////////////////////////////////////
////////////////////////////////////
//////////

import { UrlParam } from "./UrlParam";

interface IUrlParam {
    key: string;
    value: string;
}

export {
    IUrlParam,
///////////////////////
/////////////
////////////
//////////////
    UrlParam
};

/* eslint-enable */
